// extracted by mini-css-extract-plugin
export default {"control":"deV0tSVyRPO9pc3NREuO","avatar":"aDP_CDdgONGIuqe3RFwb","name":"vVgH_l7K8D87DA3AZkKy"};